export default __webpack_public_path__ + "static/media/image-ph-study-ranking-n-m.c8cee6b7.webp";